import initialState from './initialState'

import {
  ONLINE,
  OFFLINE,
  SET_STATUS_MESSAGE,
  SET_AVAILABLE_EDITOR,
  SET_EDITOR_UPDATE_AVAILABLE,
  SET_UPDATES_AVAILABLE,
  TOGGLE_PRESET_DIALOG,
  SET_USER_PRESET_NAME,
  SELECT_PRESET_DESTINATION,
  SELECT_PRESET,
  OPEN_UNSAVED_CHANGES,
  SELECT_ZONE,
  SELECT_BAR,
  SELECT_GAP_CAP,
  BAR_INFO_ACTIVE,
  SET_BAR_INFO,
  SELECT_BUTTON,
  SELECT_PEDAL,
  SELECT_FADER,
  REVERTABLE_PRESET,
  OPEN_VELOCITY_CURVES,
  CLOSE_VELOCITY_CURVES,
  INITIAL_PRESET_LOADED,
  SELECT_VELOCITY_CURVE,
  SELECT_USER_CURVE,
  DEVICE_PRESETS_LOADED,
  OPEN_PREFERENCES,
  OPEN_PRESET_RENAMER,
  CLOSE_PRESET_RENAMER,
  SET_TEMP_IMPORTED_PRESETS,
  SET_IMPORTED_PRESET_NAME,
  SET_IMPORTED_PRESET_NAMES,
  RESET_IMPORTED_NAMES,
  OPEN_LEARN_MODE,
  CLOSE_LEARN_MODE,
  SELECT_LEARN_BAR,
  SELECT_ERROR_LEARN_BAR,
  LEARN_MODE_RECORDING,
  SET_LEARN_STRIKE_TYPE,
  SET_LEARN_STRIKE_COUNT,
  LEARN_MODE_AUTO_RECORDING,
  LEARN_MODE_USE_SOUNDS,
  LEARN_MODE_COMPLETE,
  SENSITIVITY_PRESET,
  OPEN_LEARN_MODE_TOUR
} from '../actions/actionTypes'

export default function editorReducer(state = initialState.editor, action) {

  switch (action.type) {
    case ONLINE:
      return { ...state, networkConnection: true };

    case OFFLINE:
      return { ...state, networkConnection: false };

    case SET_STATUS_MESSAGE:
      return { ...state, statusMessage: action.message };

    case SET_AVAILABLE_EDITOR:
      return { ...state, availableEditor: action.version };

    case SET_EDITOR_UPDATE_AVAILABLE:
      return { ...state, editorUpdateAvailable: action.updateable > 0 };

    case SET_UPDATES_AVAILABLE:
      return { ...state, editorUpdateAvailable: action.available };

    case SELECT_PRESET_DESTINATION:
      return { ...state, destination: action.destination };

    case TOGGLE_PRESET_DIALOG:
      return { ...state, userPresetDialogOpen: !state.userPresetDialogOpen };

    case SET_USER_PRESET_NAME:
      return { ...state, userPresetName: action.name };

    case SELECT_PRESET:
      return { ...state, selectedPreset: action.selectedPreset };

    case OPEN_UNSAVED_CHANGES:
      return { ...state, unsavedChangesOpen: action.open };

    case BAR_INFO_ACTIVE:
      return { ...state, barInfoActive: action.active };

    case SET_BAR_INFO:
      return { ...state, barInfo: action.info };

    case SELECT_BAR:
      return { ...state, selectedBar: action.bar };

    case SELECT_GAP_CAP:
      return { ...state, selectedGapCap: action.cap };

    case SELECT_ZONE:
      return { ...state, selectedSplit: action.zone };

    case SELECT_BUTTON:
      return { ...state, selectedButton: action.index };

    case SELECT_PEDAL:
      return { ...state, selectedPedal: action.index };

    case SELECT_FADER:
      return { ...state, selectedFader: action.index };

    case REVERTABLE_PRESET:
      return { ...state, revertablePreset: action.diffLength };

    case OPEN_VELOCITY_CURVES:
      return { ...state, velocityCurvesOpen: true };

    case CLOSE_VELOCITY_CURVES:
      return { ...state, velocityCurvesOpen: false };

    case SELECT_VELOCITY_CURVE:
      return { ...state, selectedVelocityCurve: action.index };

    case SELECT_USER_CURVE:
      return { ...state, selectedUserCurve: action.index };

    case INITIAL_PRESET_LOADED:
      return { ...state, initialPresetLoaded: true };

    case DEVICE_PRESETS_LOADED:
      return { ...state, devicePresetsLoaded: action.status };

    case OPEN_PREFERENCES:
      return { ...state, preferencesOpen: action.open };

    case OPEN_PRESET_RENAMER:
      return { ...state, presetsImportRenameDialogOpen: true };

    case CLOSE_PRESET_RENAMER:
      return { ...state, presetsImportRenameDialogOpen: false };

    case SET_TEMP_IMPORTED_PRESETS:
      return {
        ...state,
        importedPresets: {
          ...state.importedPresets,
          presets: [...action.presets],
          duplicates: { ...action.duplicates },
        },
      };

    case SET_IMPORTED_PRESET_NAME:
      return {
        ...state,
        importedPresets: {
          ...state.importedPresets,
          renamed: {
            ...state.importedPresets.renamed,
            [action.index]: action.name,
          },
        },
      };

    case SET_IMPORTED_PRESET_NAMES:
      return {
        ...state,
        importedPresets: {
          ...state.importedPresets,
          renamed: action.names,
        },
      };

    case RESET_IMPORTED_NAMES:
      return {
        ...state,
        importedPresets: {
          presets: [],
          duplicates: {},
          renamed: {},
        },
      };

    case OPEN_LEARN_MODE:
      return { ...state, learnModeOpen: true };

    case CLOSE_LEARN_MODE:
      return { ...state, learnModeOpen: false };

    case SELECT_LEARN_BAR:
      return { ...state, selectedLearnBar: action.bar };

    case SELECT_ERROR_LEARN_BAR:
      return {
        ...state,
        errorLearnBars:
          action.bar === -1 ? [] : [...state.errorLearnBars, action.bar],
      };

    case LEARN_MODE_RECORDING:
      return { ...state, learnModeRecording: action.recording };

    case SET_LEARN_STRIKE_TYPE:
      return { ...state, learnModeStrikeType: action.strikeType };

    case SET_LEARN_STRIKE_COUNT:
      return { ...state, learnModeStrikeCount: action.count };

    case LEARN_MODE_AUTO_RECORDING:
      return { ...state, learnModeAuto: !!action.learnModeAuto };

    case LEARN_MODE_USE_SOUNDS:
      return { ...state, learnModeUseSounds: !!action.useSounds };

    case OPEN_LEARN_MODE_TOUR:
      return { ...state, learnModeTourOpen: action.open };

    case LEARN_MODE_COMPLETE:
      return { ...state, learnModeComplete: action.complete };

    case SENSITIVITY_PRESET:
      return { ...state, sensitivityPreset: action.preset };

    default:
      return state;
  }
}
